export interface BrandTheme {
  name: string;
  primaryColor: string;
  secondaryColor: string;
  buttonColor: string;
  bannerUrl: string;
  logoUrl: string;
}

export const BRAND_DICTIONARY: Record<string, BrandTheme> = {
  //TAS
  'tas-rutt.pervolare.net': {
    name: 'TAS',
    primaryColor: '#004686',
    secondaryColor: '#004686',
    buttonColor: '#C00A27',
    bannerUrl: '',
    logoUrl:
      'https://res.cloudinary.com/pervolare-org/image/upload/v1698425615/TAS/home/geop3aigtgwhisftzl7r.svg',
  },

  //Pervolare
  'solicitudreembolsos.pervolare.com': {
    name: 'Pervolare',
    primaryColor: '#1E90C3',
    secondaryColor: '#004686',
    buttonColor: '#1E90C3',
    bannerUrl: '',
    logoUrl:
      'https://res.cloudinary.com/pervolare-org/image/upload/v1776436025/TAS/rutt/Logo_SPV_azul_xf8wfv.svg',
  },

  // 3. Entorno Local
  localhost: {
    name: 'Local TAS',
    primaryColor: '#004686',
    secondaryColor: '#004686',
    buttonColor: '#004686',
    bannerUrl: 'assets/images/tas-banner.png',
    logoUrl:
      'https://res.cloudinary.com/pervolare-org/image/upload/v1698425615/TAS/home/geop3aigtgwhisftzl7r.svg',
  },
};
